import store from '@/store'
import {allowWarnings, nullString} from './utils'

// ---------------- Users ---------------- //

export function getUserRole (user) {
  let ret = null
  try {
    ret = store.getters['roles/byId']({id: user.relationships.role.data.id})
  } catch (e) { if (allowWarnings) console.warn(e) }
  return ret || {attributes: {name: nullString}}
}

export function getUserTeam (user) {
  let ret = null
  try {
    ret = store.getters['teams/byId']({id: user.relationships.team.data.id})
  } catch (e) { if (allowWarnings) console.warn(e) }
  return ret || {attributes: {name: nullString}}
}
